var render = function render(){var _vm=this,_c=_vm._self._c;return _c('footer',{staticClass:"footer"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"copyright text-center"},[_vm._v("\n      © 2009-"+_vm._s(new Date().getFullYear())+"\n      "),_c('a',{attrs:{"href":"http://www.jbgrupoempresarial.com.mx/","target":"_blank"}},[_vm._v("\n        JB GRUPO EMPRESARIAL.")]),_vm._v("\n      Todos los derechos reservados.\n    ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }


// WEBPACK FOOTER //
// ./src/pages/Dashboard/Layout/ContentFooter.vue